import * as ng from 'angular';
import * as _ from 'underscore';

export interface Language {
   code:string;
   locale:string;
   name:string;
   nameEnglish:string;
}

const langs:Language[] = require('../../../../../langs.json');

export class L10nService {
   static $inject: string[] = ['session', 'gettextCatalog'];

   constructor(
      private session,
      private gettextCatalog
   ) { }

   getTranslatedConfig(obj:any, lang:string):string {
      let campaignLangs = this.session.getCampaign().settings.languages;
      let defaultLanguage = this.session.getCampaign().defaultLanguage;

      if (lang && obj && obj[lang]) {
         return obj[lang];
      }

      if ((lang && obj && !obj[lang]) || !lang) {
         if (obj && obj[defaultLanguage]) {
            return obj[defaultLanguage];
         }

         for (let language of campaignLangs) {
            if (obj && obj[language]) {
               return obj[language];
            }
         }
      }

      return '';
   }

   getTranslatedString(str:string, lang:string):string {
      if (this.gettextCatalog.strings[lang] && this.gettextCatalog.strings[lang][str]) {
         return this.gettextCatalog.strings[lang][str].$$noContext[0];
      }

      return str;
   }

   translateObject(obj:any, key:string, str:string, languages:string[], template:string = null) {
      if (!obj[key]) {
         obj[key] = {};
      }

      for (let language of languages) {
         let s = obj[key][language];
         // set when property is null or undefined, preserve empty strings
         if (s == null || ng.isUndefined(s)) {
            s = this.getTranslatedString(str, language);

            if (template) {
               s = template.replace(`[${key}]`, s);
            }

            obj[key][language] = s;
         }
      }
   }

   getName(code:string, opts = { native: false }) {
      let lang = _.findWhere(langs, {code: code});
      if (lang) {
         return opts.native ? lang.name : lang.nameEnglish;
      }
   }

   getLanguageCodes() {
      return _.pluck(langs, 'code');
   }

   getLanguages() {
      return langs;
   }
}

ng.module('e360')
   .service('l10n', L10nService);
